import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IdentityMigrationFailureType } from '../models/IdentityMigrationFailureType';

export interface IGetUserIdentityConflictTotalsParams {
}

export interface GetUserIdentityConflictTotalsResult extends IResult {
    totalFailuresByType: { readonly [key in IdentityMigrationFailureType]: number};
    totalAcknowledgedFailures: number;
}

export class GetUserIdentityConflictTotalsRequest extends Request<IGetUserIdentityConflictTotalsParams, GetUserIdentityConflictTotalsResult> {
  constructor(params: IGetUserIdentityConflictTotalsParams = {}) {
    super('getUserIdentityConflictTotals', params);
  }
}
